module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-brands-400.8ca6e74e.ttf";